import React, { Component } from "react";

export default class Default extends Component {
  render() {
    return (
      <div className="container text-center my-5">
        <h1>404</h1>
        <h4>Page Not Found</h4>
      </div>
    );
  }
}
